import type { NumericKeys } from './types';

export const clamp = (num: number, min: number, max: number) => {
  return num > max ? max : num < min ? min : num;
};

export const sumUp = <T extends Record<string, any>>(
  arr: T[],
  key: NumericKeys<T>,
) => {
  return arr.reduce((acc, obj) => acc + (obj[key] ?? 0), 0);
};

export const findLastIndex = <T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): number => {
  let l = array.length;
  while (l--) {
    // biome-ignore lint/style/noNonNullAssertion: manually looping - we are sure its defined
    if (predicate(array[l]!, l, array)) return l;
  }
  return -1;
};

export const isFilledLine = (s: string): boolean => /^\s*$/.test(s) === false;

export const capFirst = (str: string) => {
  return str[0]?.toUpperCase() + str.slice(1);
};

export const urlJoin = (...parts: string[]) => {
  return parts
    .map((part) => part.replace(/^\/+|\/+$/g, '')) // Remove leading/trailing slashes
    .filter((part) => part.length > 0) // Remove empty parts
    .join('/');
};
